import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Hourglass, TrendingDown, AlertTriangle } from "lucide-react";

export function CreditForecast() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/my/credit-forecast").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || data.active_listings === 0) return null;

  const { balance, active_listings, per_day_cost, days_left } = data;
  const critical = days_left !== null && days_left <= 3;
  const warn = days_left !== null && days_left <= 7 && !critical;
  const border = critical ? "border-red-400/40" : warn ? "border-amber-400/40" : "border-electric/30";
  const iconClass = critical ? "text-red-400" : warn ? "text-amber-400" : "text-electric";

  return (
    <div data-testid="credit-forecast" className={`glass rounded-2xl p-5 border ${border} flex flex-wrap items-center gap-4`}>
      <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${critical ? "bg-red-500/15" : warn ? "bg-amber-500/15" : "bg-electric/15"}`}>
        <Hourglass className={`w-5 h-5 ${iconClass}`} strokeWidth={1.5} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs uppercase tracking-wide text-slate-400">Kredit előrejelzés</div>
        <div className="font-heading text-lg mt-0.5">
          {days_left !== null ? (
            <>Még kb. <b data-testid="forecast-days-left" className={critical ? "text-red-400" : warn ? "text-amber-400" : "text-electric"}>{days_left} nap</b> a hirdetéseidnek</>
          ) : (
            <>Nincs kredit-fogyasztó hirdetésed</>
          )}
        </div>
        <div className="text-xs text-slate-400 mt-1">
          <span data-testid="forecast-active">{active_listings}</span> aktív hirdetés · Napi <b data-testid="forecast-per-day">{per_day_cost}</b> kredit · Egyenleg <b>{balance}</b>
        </div>
      </div>
      {critical && (
        <div className="flex items-start gap-2 text-xs text-red-200 w-full sm:w-auto sm:max-w-xs">
          <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0 text-red-400" />
          <span>Rövidesen elfogy a kredited — a hirdetéseid automatikusan lekerülnek!</span>
        </div>
      )}
    </div>
  );
}
